import { useMutation, useQueryClient } from '@tanstack/react-query';
import discountsApi from '@/features/dashboard/discounts/api/discountsApi.ts';
import { discountsApiQueryKeys } from '@/features/dashboard/discounts/api/discountsApi.queryKeys.ts';
import { UpdateDiscountDto } from '@/features/dashboard/discounts/types/UpdateDiscountDto.ts';
import { toast } from 'sonner';

export default function useUpdateDiscount(discountId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (dto: UpdateDiscountDto) =>
      discountsApi.update(discountId, dto),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: discountsApiQueryKeys.all(),
      });
      queryClient.invalidateQueries({
        queryKey: discountsApiQueryKeys.byId(discountId),
      });
      toast.success('Zniżka została zaktualizowana');
    },
    onError: (error: Error) => {
      toast.error('Wystąpił błąd', {
        description:
          error.message || 'Wystąpił błąd podczas aktualizacji zniżki.',
      });
    },
  });
}
